module.exports = __webpack_public_path__ + "img/round4.7a76386b.png";